import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col rounded-2xl w-1/2 legend-background absolute top-32 ml-4 legend-position-mobile sm:w-60 md:right-5 md:absolute md:bottom-5 md:top-auto" }
const _hoisted_2 = { class: "text-xs text-center font-bold text-secondary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-7",
  viewBox: "0 0 100 40"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0",
    y1: "20",
    x2: "100",
    y2: "20",
    stroke: "black"
  })
], -1)

import { store } from "@/main"
import { SwitchType } from "@/classes/State"
import { computed, ref } from "vue"
import LegendSwitch from "./LegendSwitch.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MapLegend',
  setup(__props) {

const switchState = computed(() => store.getState().switch)
const showAllLegend = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("legend.title").toUpperCase()), 1),
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).rescue,
      checked: switchState.value.rescue,
      title: _ctx.$t(`legend.${_unref(SwitchType).rescue}`),
      color: "#F03E1B",
      switchable: true
    }, null, 8, ["id", "checked", "title"]),
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).transfer,
      checked: switchState.value.transfer,
      title: _ctx.$t(`legend.${_unref(SwitchType).transfer}`),
      color: "#9CA3AF",
      switchable: true,
      tooltip: [_ctx.$t(`legend.${_unref(SwitchType).transfer}`), _ctx.$t('legend.transferDescription')]
    }, null, 8, ["id", "checked", "title", "tooltip"]),
    (showAllLegend.value)
      ? (_openBlock(), _createBlock(LegendSwitch, {
          key: 0,
          id: _unref(SwitchType).medEvac,
          checked: switchState.value.medEvac,
          title: _ctx.$t(`legend.${_unref(SwitchType).medEvac}`),
          color: "#1A2747",
          switchable: true,
          tooltip: [_ctx.$t(`legend.${_unref(SwitchType).medEvac}`), _ctx.$t('legend.medEvacDescription')]
        }, null, 8, ["id", "checked", "title", "tooltip"]))
      : _createCommentVNode("", true),
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).death,
      checked: switchState.value.death,
      title: _ctx.$t(`legend.${_unref(SwitchType).death}`),
      iconName: "deaths.svg",
      switchable: true
    }, null, 8, ["id", "checked", "title"]),
    (showAllLegend.value)
      ? (_openBlock(), _createBlock(LegendSwitch, {
          key: 1,
          id: _unref(SwitchType).shipwreck,
          checked: switchState.value.shipwreck,
          title: _ctx.$t(`legend.${_unref(SwitchType).shipwreck}`),
          iconName: "shipwreck.png",
          switchable: true
        }, null, 8, ["id", "checked", "title"]))
      : _createCommentVNode("", true),
    (showAllLegend.value)
      ? (_openBlock(), _createBlock(LegendSwitch, {
          key: 2,
          id: _unref(SwitchType).incident,
          checked: switchState.value.incident,
          title: _ctx.$t(`legend.${_unref(SwitchType).incident}`),
          iconName: "incident.png",
          switchable: true
        }, null, 8, ["id", "checked", "title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "legend-toggler",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllLegend.value = !showAllLegend.value))
    }, _toDisplayString(showAllLegend.value ? _ctx.$t("legend.less") : _ctx.$t("legend.more")), 1),
    _hoisted_3,
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).harbor,
      checked: switchState.value.harbor,
      title: _ctx.$t(`legend.${_unref(SwitchType).harbor}`),
      iconName: "harbor.png",
      switchable: false
    }, null, 8, ["id", "checked", "title"]),
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).srr,
      checked: switchState.value.srr,
      title: _ctx.$t(`legend.${_unref(SwitchType).srr}`),
      iconName: "srr.png",
      class: "srr",
      switchable: false,
      tooltip: [_ctx.$t(`legend.${_unref(SwitchType).srr}`), _ctx.$t('legend.srrDescription')]
    }, null, 8, ["id", "checked", "title", "tooltip"]),
    _createVNode(LegendSwitch, {
      id: _unref(SwitchType).zone12Miles,
      checked: switchState.value.zone12Miles,
      title: _ctx.$t(`legend.water`),
      iconName: "territorial_water.png",
      switchable: false,
      tooltip: [_ctx.$t(`legend.water`), _ctx.$t('legend.waterDescription')]
    }, null, 8, ["id", "checked", "title", "tooltip"])
  ]))
}
}

})